import { Http } from '@pirates/not-morty-biz';
import { Company } from '../../company.model';
import { Address, AddressValidation } from '../company-address-form/company-address.model';

export class CompanyAddressService {
  public async update(id: number, address: Address, updateBillingAddress: boolean) {
    return Http.put<Company>(`/api/b2b/bo-api/v1/customer/companies/${id}/address?updateBillingAddress=${updateBillingAddress}`, address);
  }

  public async getValidation(id: number) {
    return Http.get<AddressValidation>(`/api/b2b/bo-api/v1/customer/companies/${id}/address/validation`);
  }
}

export const companyAddressService = new CompanyAddressService();
